<template>
  <div class="classification">
    <EsHeaderView />
    <div v-if="isPreview" style="background: linear-gradient(135deg, #4d6bfe, #7388ff); color: #fff; text-align: center; padding: 8px 16px; font-size: 13px; font-weight: 500; position: sticky; top: 0; z-index: 100;">{{ $t('message.home.🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）') }}</div>
    <DecorationRenderer v-if="useDecoration" :components="decorationComponents" :scope-page-type="1" />
    <div v-if="!useDecoration" class="app-container app-center">
      <h1 class="classification-title">
        {{ this.$t("message.home.classification" /**分类 */) }}
      </h1>
      <div style="min-width: 1200px">
        <EsLoadingView v-loading="loading">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-for="(item, index) in objsList" :key="index"
              @click.native="gotoCommodityPage(item.id)">
              <el-row class="classification-item" type="flex" align="middle" :gutter='10'>
                <el-col :span="8">
                  <div class="cla-img">
                    <img :src="item.image" alt="" />
                  </div>
                </el-col>
                <el-col :span="15">
                  <div class="classification-item-text ">
                    <h2>{{ item.name }}</h2>
                    <div v-if="item.children.length">
                      <span v-for="(i, index) in item.children" :key="index"
                        @click.stop="gotoCommodityPage(i.id, item.id)">
                        {{ i.name }}
                      </span>
                    </div>
                    <p v-else>{{ item.seoDescription }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="no-data" v-if="!objsList.length && !loading">
            <el-empty :description="$t('message.home.noData')"></el-empty>
          </div>
        </EsLoadingView>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
// import { mapActions, mapGetters } from "vuex";
// import { CategoryApiList } from "@/api/home";
import {
  index
} from "@/api/goods/goods_category.js"
import {
  message
} from "@/api/upms/i18n.js"
import { sync } from "which";
import DecorationRenderer from "@/components/decoration/DecorationRenderer.vue";
import { getDecorationPage } from "@/api/upms/decoration";
export default {
  name: "EsClassification",
  components: { DecorationRenderer },
  data() {
    return {
      useDecoration: false,
      decorationComponents: [],
      isPreview: false,
      loading: false,
      pageNum: 1,
      categoryList: [],

      // messages: app.globalData.messages,
      // appGlobal: app.globalData,
      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      objsList: [],
      treeChildren: [],
      // 数据缓存
      currType: 0,
      activeIndex: 0,
      typeTree: [],
      bigTypes: [],
      typeName: "",
      typeIndex: 1
    };
  },
  computed() {
    this.goods_category_index();
    // ...mapGetters("home", ["categoryList"]),
  },
  mounted() {
    this.loadDecoration();
    this._onDecorationLiveUpdate = (e) => {
      const detail = e && e.detail;
      if (!detail || Number(detail.pageType) !== 1) return;
      this.decorationComponents = detail.components || [];
      this.useDecoration = this.decorationComponents.length > 0;
    };
    window.addEventListener('decoration-live-update', this._onDecorationLiveUpdate);
  },
  beforeDestroy() {
    if (this._onDecorationLiveUpdate) {
      window.removeEventListener('decoration-live-update', this._onDecorationLiveUpdate);
    }
  },
  methods: {

    /** 拉取已发布的分类页装修配置；有则装修渲染、无则回退写死分类列表。?previewPageId=xxx 走草稿接口供装修器预览 */
    loadDecoration() {
      const previewPageId = this.$route && this.$route.query && this.$route.query.previewPageId;
      const params = previewPageId ? { previewPageId } : { terminalType: 0, pageType: 1 };
      getDecorationPage(params).then(r => {
        const page = r && r.data && r.data.data;
        if (page && page.pageType != null && Number(page.pageType) !== 1) {
          return;
        }
        if (page && page.componentListJson) {
          let parsed = null;
          try { parsed = JSON.parse(page.componentListJson); } catch (e) { parsed = null; }
          if (parsed && Array.isArray(parsed.components) && parsed.components.length) {
            this.decorationComponents = parsed.components;
            this.useDecoration = true;
            this.isPreview = !!previewPageId;
          }
        }
        if (!this.useDecoration) this.goods_category_index();
      }).catch(() => { this.goods_category_index(); });
    },

    goods_category_index() {
      this.loading = true;
      // let	 res = await	index();
      index().then(response => {
        this.loading = false;
        this.objsList = response.data.data;
        this.treeChildren = this.objsList[0].children;
        this.objsList[0].status = "active";
      }).catch(error => {

      })



    },



    // ...mapActions("home", ["requestCategoryList"]),
    // async getCategoryList() {
    //   const res = await CategoryApiList();
    // this.categoryList = res.data.filter((item) => {
    //   if (item.name && item.subList.length > 0) {
    //     item.subList = item.subList.filter((subItem) => subItem.name);
    //   }
    //   return item.name;
    // });
    // this.categoryList = res.data.slice(0, 20);
    // },


    // async requestData(params = {}) {
    //   try {
    //     this.loading = true;
    //     this.requestCategoryList({
    //       pageNum: this.pageNum,
    //       pageSize: "50",
    //       ...params,
    //     });
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    currentChange(page) {
      this.pageNum = page;
      this.requestCategoryList({ pageNum: page });
    },
    gotoCommodityPage(id, parentId) {
      this.$router.push({ name: "commodity", query: { id, id } });
    },
  },
};
</script>

<style lang="scss">
.classification {
  &-title {
    font-weight: 700;
    font-size: 24px;
    color: var(--color-title);
    margin: 24px 0;
  }

  &-item {
    border: 1px solid var(--color-border);
    padding: 24px;
    border-radius: 4px;
    margin: 0 !important;
    margin-bottom: 20px !important;
    height: 234px;
    cursor: pointer;

    .el-col {
      height: 100%;
    }

    .cla-img {
      height: 170px;
      width: 170px;
      overflow: hidden;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        // min-height: 179px;
        // min-width: 179px;
      }
    }

    &-text {
      h2 {
        font-weight: 700;
        font-size: 20px;
        color: var(--color-title);
        margin-bottom: 14px;
      }

      p {
        font-weight: 400;
        font-size: 13px;
        color: #333;
        line-height: 1.5;
        overflow: hidden;
        height: 140px;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 7;
      }

      span {
        &:hover {
          color: var(--color-main);
          ;
          font-size: 15px;
        }

        // color: blue;
      }
    }
  }
}
</style>
